import {
  GET_RECONCILIATION_FORMS,
  SET_RECONCILIATION_FORMS_LOADING
} from 'constants/types';

const INITIAL_STATE = {
  records: [],
  contacts: null,
  loading: false
};

export default function reconciliationFormsReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case GET_RECONCILIATION_FORMS: {
      const p = action.payload;
      if (Array.isArray(p)) {
        return { ...state, records: p, contacts: null, loading: false };
      }
      return {
        ...state,
        records: p?.records ?? [],
        contacts: p?.contacts ?? null,
        loading: false
      };
    }
    case SET_RECONCILIATION_FORMS_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}
